import {
  TAutomatedReferralOfficeRelationData,
  TAutomatedReferralRejectionReasonData,
  TAutomatedReferralTermsData,
  TReceivedReferralData,
  TReceivedReferralDetailsData,
} from "types/automated-referrals.type";
import { TLeadWithDetails } from "types/lead.type";
import { BaseApi } from "./base.api";

export class AccountAutomatedReferralsApi extends BaseApi {
  async fetchAccountOfficeRelations(
    accountId: number
  ): Promise<TAutomatedReferralOfficeRelationData[]> {
    const data = await this.get<TAutomatedReferralOfficeRelationData[]>(
      `accounts/${accountId}/automated-referrals/office-relations`
    );

    return data;
  }

  async fetchReceivedReferrals(
    accountId: number
  ): Promise<TReceivedReferralData[]> {
    return this.get(
      `accounts/${accountId}/automated-referrals/received-referrals`
    );
  }

  async fetchReceivedReferralDetails(
    accountId: number,
    referralId: number
  ): Promise<TReceivedReferralDetailsData> {
    return this.get(
      `accounts/${accountId}/automated-referrals/received-referrals/${referralId}`
    );
  }

  async fetchTerms(accountId: number): Promise<TAutomatedReferralTermsData> {
    return this.get(`accounts/${accountId}/automated-referrals/terms`);
  }

  async fetchRejectionReasons(
    accountId: number
  ): Promise<TAutomatedReferralRejectionReasonData[]> {
    return this.get(
      `accounts/${accountId}/automated-referrals/rejection-reasons`
    );
  }

  async acceptReceivedReferral(
    accountId: number,
    referralId: number,
    termsId: number
  ): Promise<TLeadWithDetails> {
    return this.post(
      `accounts/${accountId}/automated-referrals/received-referrals/${referralId}/accept`,
      { termsId }
    );
  }

  async rejectReceivedReferral(
    accountId: number,
    referralId: number,
    rejectionReasonId: number,
    notes?: string
  ) {
    await this.post(
      `accounts/${accountId}/automated-referrals/received-referrals/${referralId}/reject`,
      { rejectionReasonId, notes }
    );
  }

  async updateSyncedOffices(
    accountId: number,
    relationsData: TAutomatedReferralOfficeRelationData[]
  ) {
    await this.post(
      `accounts/${accountId}/automated-referrals/office-relations`,
      {
        items: relationsData,
      }
    );
  }
}
